import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'
import { createGlobalStyle } from 'styled-components'
import FKRoman from '../assets/fonts/FKRomanStandard.woff2'
import UntitledMedium from '../assets/fonts/untitled-sans-web-medium.woff2'
import UntitledMediumItalic from '../assets/fonts/untitled-sans-web-medium-italic.woff2'
import UntitledRegular from '../assets/fonts/untitled-sans-web-regular.woff2'
import UntitledRegularItalic from '../assets/fonts/untitled-sans-web-regular-italic.woff2'

const media = {
  medium: '@media(min-width:700px)',
  large: '@media(min-width:1200px)',
  xLarge: '@media(min-width:1800px)'
}

const GlobalStyles = createGlobalStyle`
    
    @font-face {
        font-family: "FK Roman";
        src: url(${FKRoman});
    }

    @font-face {
        font-family: "Untitled Sans" ;
        font-weight: 500;
        src: url(${UntitledMedium});
    }
    @font-face {
        font-family: "Untitled Sans" ;
        font-weight: 500;
        font-style: italic;
        src: url(${UntitledMediumItalic});
    }

    @font-face {
        font-family: "Untitled Sans" ;
        font-weight: 400;
        src: url(${UntitledRegular});
    }

    @font-face {
        font-family: "Untitled Sans" ;
        font-weight: 400;
        font-style:italic;
        src: url(${UntitledRegularItalic});
    }

    
		
    
    :root{
        --black: rgb(0,0,0);
        --light: rgb(248,248,248);
        --white: rgb(252,252,252);
        --slate: #5E7290;
        --left-margin: 15vw;

        /* --bg-color: ${props =>
          props.backgroundColor ? props.backgroundColor : 'red'}; */
        /* --text-color: ${props =>
          props.textColor ? props.textColor : 'black'}; */
        --bg-color:#f4f4f4;
        --text-color:#000000;
        --small-text: 13px;
        --medium-text: 15px;
        --large-text:20px;
        --serif: "FK Roman", BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
        --sans:  "Untitled Sans", BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
        
        ${media.medium}{
            --small-text:14px;
            --medium-text:18px;
            --large-text:24px;
            --left-margin: 10vw;

        }

        ${media.large}{
            --small-text:18px;
            --large-text:32px;
        }

    }

    body{
        -webkit-font-smoothing: antialiased;
        background:var(--light);
        font-family: var(--serif);

        
        /* font-family: "Proto Grotesk", BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"; */
        color:var(--text-color);
        font-size:2rem;
        margin:0;
    }

    .home-link{
        font-weight:500;
        text-decoration:none;
        margin-right: 1em;
        display:inline-block;
        font-family:var(--sans);
        transform:translateX(-4em);
        font-size:var(--small-text);
        color:rgb(120,120,120);
        letter-spacing:0.05em;
    }

    a{
        color:var(--text-color)};
    }
`

export default GlobalStyles
